import React, { useEffect, useState, useCallback } from "react";
import "./tournament-list.scss";
import {
  GSListPage,
  GSInput,
  GSItemList,
  GSEmptyList,
} from "golfstatus_react_components";
import { useDispatch, connect, useSelector } from "react-redux";
import {
  searchAllEvents,
  selectEmptyTournament,
  selectListFilterStatus,
  setAllEvents,
  setCurrentTournament,
  setFilterStatus,
} from "../../reducers/tournamentSlice";
import {
  faTimesCircle,
  faPlus,
  faStream,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import TournamentLineItem from "../tournament-line-item";
import { useMatch } from "react-router-dom";
import { Outlet } from "react-router-dom";

import { useIntercom } from "react-use-intercom";
import { getDateTime } from "../../helpers/Dates";
import { usePermissions } from "../../hooks/permissionHooks";
import { selectLoggedInUser } from "../../reducers/appSlice";

const EventList = (props) => {
  const { allEvents, loading } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const match = useMatch("/tournaments/*");
  const filterStatus = useSelector(selectListFilterStatus);

  const [filter, setFilter] = useState({
    page: {
      number: 1,
      size: 25,
    },
    name: "",
    status: filterStatus?.value,
    start_date: filterStatus?.start_date,
    end_date: filterStatus?.end_date,
  });
  const [filterButtons, setFilterButtons] = useState([]);
  const [name, setName] = useState("");
  const emptyTournament = useSelector(selectEmptyTournament);
  const currentUser = useSelector(selectLoggedInUser);

  const intercom = useIntercom();

  const { userHasAccess } = usePermissions();

  const getPageActions = () => {
    if (userHasAccess && currentUser?.organizationUsers?.length > 0) {
      return [
        {
          id: 1,
          buttonTitle: "Create Tournament",
          type: "black mobile-icon",
          actionClick: addEvent,
          actionIcon: faPlus,
        },
      ];
    }
    return [];
  };

  const getSearchActions = () => {
    return [{ id: 1, actionIcon: faStream, actionClick: openFilter }];
  };

  const openFilter = () => {
    navigate("filter");
  };

  const loadFilter = useCallback(() => {
    const filterButtons = [];
    if (filter?.status !== "all") {
      filterButtons?.push({
        name: filterStatus.label,
        removeAction: () => {
          setFilter({
            ...filter,
            name: name,
            page: { ...filter?.page, number: 1 },
            status: "all",
            start_date: filter.start_date,
            end_date: filter.end_date,
          });
          dispatch(
            setFilterStatus({
              ...filterStatus,
              label: "All Tournaments",
              value: "all",
            })
          );
        },
      });
    }

    if (filter?.start_date !== "") {
      filterButtons?.push({
        name: `From ${getDateTime(filter.start_date)}`,
        removeAction: () => {
          setFilter({
            ...filter,
            name: name,
            page: { ...filter?.page, number: 1 },
            status: filter.status,
            start_date: "",
            end_date: filter.end_date,
          });
          dispatch(setFilterStatus({ ...filterStatus, start_date: "" }));
        },
      });
    }

    if (filter?.end_date !== "") {
      filterButtons?.push({
        name: `To ${getDateTime(filter.end_date)}`,
        removeAction: () => {
          setFilter({
            ...filter,
            name: name,
            page: { ...filter?.page, number: 1 },
            status: filter.status,
            start_date: filter.start_date,
            end_date: "",
          });
          dispatch(setFilterStatus({ ...filterStatus, end_date: "" }));
        },
      });
    }
    if (filterButtons.length > 0) {
      setFilterButtons(filterButtons);
    } else {
      setFilterButtons([]);
    }
  }, [dispatch, filter, filterStatus, name]);

  const clearFilterItem = (filterItem) => {
    filterItem.removeAction?.();
  };

  useEffect(() => {
    loadFilter();
  }, [loadFilter]);

  useEffect(() => {
    const f = {
      page: {
        number: filter.page.number,
        size: filter.page.size,
      },
      name: filter.name,
      status: filter.status,
      start_date: filter.start_date,
      end_date: filter.end_date,
    };

    if (filter.page.number === 1) {
      dispatch(setAllEvents([]));
    }
    dispatch(searchAllEvents(f));
  }, [
    filter.page.number,
    filter.page.size,
    filter.name,
    filter.status,
    filter.start_date,
    filter.end_date,
    dispatch,
  ]);

  useEffect(() => {
    setFilter((prevfilter) => ({
      ...prevfilter,
      status: filterStatus?.value,
      start_date: filterStatus?.start_date,
      end_date: filterStatus?.end_date,
      page: { number: 1, size: 25 },
    }));
  }, [
    filterStatus,
    filterStatus?.value,
    filterStatus?.start_date,
    filterStatus?.end_date,
  ]);

  const isSidePanelOpen = () => {
    return match?.params?.["*"] !== "";
  };
  const getRouter = () => {
    return <Outlet />;
  };

  const getListPage = (title) => {
    const page = {
      title: title,
      getDefaultSearch: getDefaultSearch,
      getItemList: getItemList,
      getPageActions: getPageActions,
      getSearchActions: getSearchActions,
      loadMore: loadMore,
      getRouter: getRouter,
      isSidePanelOpen: isSidePanelOpen,
      filterButtons: filterButtons,
      clearFilterItem: clearFilterItem,
    };
    return <GSListPage {...page} />;
  };

  const searchChanged = (e) => {
    setName(e.target.value);
  };

  const submitSearch = () => {
    setFilter({ ...filter, name: name, page: { ...filter?.page, number: 1 } });
  };

  const loadMore = () => {
    if (loading?.length > 0) {
      return;
    }
    setFilter({
      ...filter,
      page: { ...filter?.page, number: filter?.page?.number + 1 },
    });
  };

  const clearText = () => {
    setName("");
    setFilter({ ...filter, name: "", page: { ...filter?.page, number: 1 } });
  };

  const clearFilter = () => {
    setName("");
    setFilter({
      ...filter,
      name: "",
      start_date: "",
      end_date: "",
      status: "all",
      page: { ...filter?.page, number: 1 },
    });
    dispatch(
      setFilterStatus({
        label: "All Tournaments",
        value: "all",
        start_date: "",
        end_date: "",
      })
    );
  };

  const getDefaultSearch = () => {
    return (
      <div className="event-search">
        <GSInput
          textValue={name}
          leftIcon={faSearch}
          rightIconClick={clearText}
          rightIcon={faTimesCircle}
          onChange={searchChanged}
          onSubmit={submitSearch}
          placeholder="Search by Tournament Name..."
        ></GSInput>
      </div>
    );
  };

  const selectEvent = (event) => {
    if (isSidePanelOpen()) {
      navigate("/tournaments");
      return;
    }
    navigate(`/${event.id}`);
  };

  const addEvent = (event) => {
    dispatch(setCurrentTournament(emptyTournament));
    navigate(`/tournaments/new`);
  };

  const copyEvent = (event) => {
    dispatch(setCurrentTournament(emptyTournament));
    navigate(`/tournaments/copy/${event.id}`);
  };

  const contactGolfStatus = () => {
    intercom.show();
  };

  const getEmptyListMessage = () => {
    return (
      <GSEmptyList
        title="Create & Manage Tournaments"
        detail="GolfStatus simplifies and streamlines golf tournaments. Let's get started!"
        actions={[
          {
            title: "Create Tournament",
            buttonIcon: faPlus,
            onClick: addEvent,
            type: "black",
          },
        ]}
      />
    );
  };

  const getUnAuthorizedListMessage = () => {
    return (
      <GSEmptyList
        title="Your organization does not currently have access to TMS."
        detail="Please contact GolfStatus to get started!"
        actions={[
          {
            title: "Contact Golfstatus",
            onClick: contactGolfStatus,
            type: "black",
          },
        ]}
      />
    );
  };

  const getEmptySearchMessage = () => {
    return (
      <GSEmptyList
        title="We couldn’t find the tournament you’re looking for…"
        detail="Try changing the search term and filter or create a new tournament."
        actions={[
          {
            title: "Clear All",
            onClick: clearFilter,
            type: "light-grey",
          },
          {
            title: "Create Tournament",
            buttonIcon: faPlus,
            onClick: addEvent,
            type: "black",
          },
        ]}
      />
    );
  };

  const getEmptyMessage = () => {
    if (userHasAccess) {
      return filter?.name !== ""
        ? getEmptySearchMessage()
        : getEmptyListMessage();
    } else {
      return getUnAuthorizedListMessage();
    }
  };

  const getItemList = () => {
    return (
      <GSItemList
        items={allEvents}
        listItem={(event) => (
          <TournamentLineItem tournament={event} copyTournament={copyEvent} />
        )}
        itemSelected={selectEvent}
        type="vertical selectable tournament-list"
        emptyMessage={getEmptyMessage()}
        loading={loading?.includes?.("searchAllEvents")}
        loadingMainText="Searching for Tournaments..."
      ></GSItemList>
    );
  };

  return <event-list>{getListPage("My Tournaments")}</event-list>;
};

const mapStateToProps = (state) => ({
  allEvents: state.tournaments.allEvents,
  loading: state.tournaments.loading,
});

export default connect(mapStateToProps)(EventList);
